import { render, staticRenderFns } from "./bottom-bar.vue?vue&type=template&id=1e9bc3dc&scoped=true"
import script from "./bottom-bar.vue?vue&type=script&lang=js"
export * from "./bottom-bar.vue?vue&type=script&lang=js"
import style0 from "./bottom-bar.vue?vue&type=style&index=0&id=1e9bc3dc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9bc3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e9bc3dc')) {
      api.createRecord('1e9bc3dc', component.options)
    } else {
      api.reload('1e9bc3dc', component.options)
    }
    module.hot.accept("./bottom-bar.vue?vue&type=template&id=1e9bc3dc&scoped=true", function () {
      api.rerender('1e9bc3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flow/bottom-bar.vue"
export default component.exports